import type {AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders, Method} from 'axios'
import type {IncomingMessage} from 'http'

export function getHeaderFromReq(req: IncomingMessage) {
    const referer = req.headers.referer || ''
    const cookie = req.headers.cookie || ''
    const userAgent = req.headers['user-agent'] || ''
    const clientIp = req.headers['x-real-ip'] || ''

    return {
        referer,
        cookie,
        'user-agent': userAgent,
        'x-nf-client-ip': clientIp,
    } as unknown as AxiosRequestHeaders
}

export interface ExtendAxiosRequestConfig extends AxiosRequestConfig {
    method: Method // method 반드시 명시해서 호출
    req?: IncomingMessage
}

export function createApi(axiosInstance: AxiosInstance) {
    return async function api<Result>(url: string, requestConfig?: ExtendAxiosRequestConfig) {
        const {req} = requestConfig || {}

        const result = await axiosInstance.request<Result>({
            ...requestConfig,
            ...(req ? {headers: getHeaderFromReq(req)} : {}),
            url,
        })

        return result
    }
}
